import React from 'react'
import Query from './Query'
import Layout from '../Layout'
import Hero, { HeroTitle } from '../Hero'
import styled from 'styled-components'
import { toRGB, toCMYK } from '../../helpers/color'
import Image from '../Image'
import Button from '../Button'

const Content = styled.div``

const SectionsContainer = styled.div`
  margin: 4rem 0;
  display: flex;

  @media screen and (max-width: 800px) {
    display: block;
  }
`

const Section = styled.div`
  background-color: ${({ inverted }) => (inverted ? '#000000' : '#ffffff')};
  padding: 1rem 3rem;
  flex: 1;

  img {
    display: block;
    margin: 4rem auto;
  }

  @media screen and (max-width: 800px) {
    max-width: 40rem;
    margin: 0 auto;
    display: block;
  }
`

const BrandColors = styled.ul`
  list-style: none;
  text-align: center;
  width: 100%;
  margin: 0;

  li {
    display: flex;
  }
`

const Value = styled.p`
  text-align: ${({ align }) => align};
  display: inline-block;
  flex: 6;
  padding-left: ${({ align }) => (align === 'left' ? 1 : 0)}rem;
  padding-right: ${({ align }) => (align === 'right' ? 1 : 0)}rem;

  span {
    &:after {
      content: ', ';
    }

    &:last-of-type:after {
      content: '';
    }
  }

  @media screen and (max-width: 550px) {
    span {
      display: block;

      &:after {
        content: '';
      }
    }
  }
`

const ColorBlock = styled.div`
  flex: 1;
  position: relative;
  min-width: 4rem;

  &:after {
    content: '';
    display: block;
    width: 2rem;
    height: 2rem;
    left: 50%;
    position: absolute;
    transform: translateX(-50%);
    background-color: ${({ value }) => value};
    border: 0.2rem solid ${({ theme }) => theme.colors.text};
  }
`

const BrandColorsTitle = styled.h2`
  text-align: center;
`

const CallToAction = styled.div`
  text-align: center;
`

export default () => (
  <Query
    render={(content) => (
      <Layout>
        <Hero>
          <HeroTitle useH1>{content.title}</HeroTitle>
        </Hero>
        <Content>
          <BrandColorsTitle>{content.brand_colors_title}</BrandColorsTitle>
          <BrandColors>
            {content.brand_colors.map((brandColor) => (
              <li key={brandColor.hex}>
                <Value align="right">
                  <span>R {toRGB(brandColor.hex).r}</span>
                  <span>G {toRGB(brandColor.hex).g}</span>
                  <span>B {toRGB(brandColor.hex).b}</span>
                </Value>
                <ColorBlock value={brandColor.hex} />
                <Value align="left">
                  <span>C {toCMYK(brandColor.hex).c}%</span>
                  <span>M {toCMYK(brandColor.hex).m}%</span>
                  <span>Y {toCMYK(brandColor.hex).y}%</span>
                  <span>K {toCMYK(brandColor.hex).k}%</span>
                </Value>
              </li>
            ))}
          </BrandColors>
          <SectionsContainer>
            <Section>
              <Image src={content.regular_logo} size={200} alt="IOHK logo" />
              <Image
                src={content.regular_symbol}
                size={200}
                alt="IOHK symbol"
              />
            </Section>
            <Section inverted>
              <Image
                src={content.inverted_logo}
                size={200}
                alt="IOHK logo inverted"
              />
              <Image
                src={content.inverted_symbol}
                size={200}
                alt="IOHK symbol inverted"
              />
            </Section>
          </SectionsContainer>
          <CallToAction>
            <Button
              tracking={{ label: 'media_kit_iohk_download' }}
              href={content.href}
            >
              {content.download}
            </Button>
          </CallToAction>
        </Content>
      </Layout>
    )}
  />
)
